import React, { Fragment, useState, useEffect } from 'react'
import styles from "./lending-service-providers.module.scss"
import UIModal from '../../../../components/common/ui-components/surface/UIModal';
import Button from '../../../../components/common/ui-components/input/Button';
import Image from 'common/components/UI/Image';


const LendingServicePartners = (props:any) => {

    const [isMobile, setMobilView] = useState<boolean>(false)

    useEffect(()=>{
        window.innerWidth < 769 ? setMobilView(true) : setMobilView(false)
        window.addEventListener('resize',(e) => {
            if(window.innerWidth > 769) {
                setMobilView(false)
            }
            else {
                setMobilView(true)
            }
        });
    },[])

    const [modal,setModal] = useState<boolean>(false)
    const [modalData,setModalData]=useState<any>({})

    const closeModal = () => {
        setModal(false)
        document.documentElement.style.overflowY="auto"
    }

    const openModelandSetData = (items) => {
        setModal(true)
        setModalData(items)
        document.documentElement.style.overflowY="hidden"
    }
    const values = [
        {
            image: "/static/images/lending-service-partners/piramal.png",
            title: "Piramal Finance",
            full_title: 'Piramal Consulting Private Limited',
            description: "Piramal Capital &amp; Housing Finance Limited (PCHFL), wholly owned subsidiary of Piramal Enterprises Limited, is registered as a housing finance company with National Housing Bank (NHB) and engaged in various financial services businesses. It provides both wholesale &amp; retail funding opportunities across industry sectors.",
            gro_name: "Hetal Parihar",
            gro_email: "nodal.officer@piramal.com",
            partners_website: "https://www.piramalfinance.com/contact-us",
            partners_privacy_policy: "https://www.piramal.com/privacy-policy",
            contact_number: "022-71740555"

        },
        {
            image: '/static/images/lending-service-partners/setu.png',
            title: "Setu",
            full_title: "BrokenTusk Technologies Private Limited",
            description: "Brokentusk Technologies Private Limited, doing business as SETU, operates as a technology company. The Company specializes in application programming interface infrastructure start-up. ",
            gro_name: "Senior Legal Counsel ",
            gro_email: "legal@setu.co ",
            partners_website: "http://www.setu.co",
            partners_privacy_policy: "https://setu.co/privacy-policy"
        },
        {
            image: '/static/images/lending-service-partners/wizdm.webp',
            title: "Moneyview",
            full_title: "Whizdm Finance Private Limited",
            description: "Whizdm Finance Private Limited incorporated on March 27, 2017 is registered with Reserve Bank of India as Non–Deposit taking, Non-Banking Financial Company. We believe access to financial services is a basic right of all individuals. We provide personal loan, business loan and purchase financing",
            gro_name: "Mr. Saurav Goyal",
            gro_email: "Head.GR@whizdmfinance.com",
            partners_website: "https://whizdmfinance.com/",
            contact_number: "080-45692004"
        },
        
    ]
    return(
        <div>
            <div className={`${styles.icon__layout} container`}>
                {values.map((items,index)=>{
                    return (
                        <div role='Button' key={index} className={styles.icon__container} onClick={()=>{
                            openModelandSetData(items)
                        }}>
                        <Image src={items.image} width={isMobile ? "80px":"153px"} height={isMobile ? "48px":"90px"} alt="LSP logo" />
                        </div>
                    )
                })}
            </div>
            {Object.keys(modalData).length ?  
                <UIModal isPlainBG={true} isOpen={modal} onClick={closeModal} onOverlayClick={isMobile ? ()=>{}:closeModal} medium>
                    <div className={styles.modal_container} >
                        <h2>{modalData?.title}</h2>
                        <div className={styles.line} />
                        <div className={styles.content_container}>
                            <p className={styles.description}>{modalData?.description}</p>
                            <h4 className={styles.full_title}>{modalData?.full_title}</h4>
                            <p className={styles.name}><span className={styles.bold}>GRO Name - </span>{modalData?.gro_name}</p>
                            <p className={styles.name}><span className={styles.bold}>GRO Email ID - </span>{modalData?.gro_email}</p>
                            <p className={styles.name}><span className={styles.bold}>Partner Website - </span><a href={modalData?.partners_website} target='_blank'>{modalData?.partners_website}</a></p>
                            {modalData?.partners_privacy_policy &&
                                <p className={styles.name} ><span className={styles.bold}>Partner’s Privacy Policy - </span><a href={modalData?.partners_privacy_policy} target='_blank'>{modalData?.partners_privacy_policy}</a></p>
                            }
                            {modalData?.contact_number ?
                                <p className={styles.name} ><span className={styles.bold}>Contact Number - </span>{modalData?.contact_number}</p>:null
                            }
                        </div>
                    </div>
                    {isMobile && 
                        <div className={styles.button_container}> 
                            <Button thin onClick={closeModal} text='OKAY' className={styles.button}></Button>
                        </div>
                    }
                </UIModal>:null
            }
        </div>
    )
}

export default LendingServicePartners;
